// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/workflow-management/page"
import { usePageHead } from "../../compat/head"

export const Route = createFileRoute("/workflow-management/")({
  component: PageComponent,

})

function PageComponent() {
  usePageHead({ title: "Thành công" })
  return <Page />
}
